const BellIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.25 3.98682V4.76807C16.1016 5.354 18.25 7.854 18.25 10.8618V11.604C18.25 13.4399 18.9141 15.2368 20.125 16.604L20.3985 16.9165C20.75 17.3071 20.8281 17.8149 20.6328 18.2837C20.4375 18.7134 19.9688 18.9868 19.5 18.9868H4.50002C3.9922 18.9868 3.52345 18.7134 3.32814 18.2837C3.13283 17.8149 3.21095 17.3071 3.56252 16.9165L3.83595 16.604C5.04689 15.2368 5.75002 13.4399 5.75002 11.604V10.8618C5.75002 7.854 7.85939 5.354 10.75 4.76807V3.98682C10.75 3.32275 11.2969 2.73682 12 2.73682C12.6641 2.73682 13.25 3.32275 13.25 3.98682ZM12 22.7368C11.336 22.7368 10.6719 22.5024 10.2031 22.0337C9.73439 21.5649 9.50002 20.9009 9.50002 20.2368H14.5C14.5 20.9009 14.2266 21.5649 13.7578 22.0337C13.2891 22.5024 12.625 22.7368 12 22.7368Z"
        fill="white"
      />
    </svg>
  );
};
export default BellIcon;
